import {React} from 'external/react'
import FaIcon from 'external/font-awesome'
import {ToggleButton, ToggleButtonGroup, styled} from 'external/material'

const validFormats = ["xlsx", "csv"]
const formatIcons = {xlsx: 'faFileExcel', csv: 'faFileCsv'}

const StyledTogleExportFormat = styled(ToggleButtonGroup)(toogleExportFormats)

export default function ToggleExportFormat(props) {
  const {format, handleFormatChange, translate} = props
  return (
    <StyledTogleExportFormat
      color="primary"
      value={format}
      exclusive
      onChange={(_, format) => handleFormatChange(format)}
      aria-label="Platform"
    >
      {validFormats.map((value, index) => (
        <ToggleButton className="button" key={index} value={value}>
          <span className="label">{translate(`export-rollbook-format-${value}`)}</span>
          <span className="icon"><FaIcon name={formatIcons[value]} /></span>
        </ToggleButton>
      ))}
    </StyledTogleExportFormat>
  )
}

function toogleExportFormats() {
  return {
    "& .button": {
      padding: "5px 15px",
      "& .label": {
        textTransform: 'capitalize',
        marginRight: 8,
        fontSize: '12pt'
      },
      "& .icon": {
        fontSize: '18px'
      }    
    },
  }
}